import { apicall } from "../../services/api";
import { reducersActions } from "./new-actions";


export const getAllUsers = (updateUser) => async (dispatch, getState) => {
	if (!updateUser) {
		const { userReducer } = getState();
		if (userReducer?.users?.length > 0) return userReducer?.users;
	}
	try {
		dispatch({ type: reducersActions?.GET_USERS_REQUEST });
		const res = await apicall(`users`, "get");
		dispatch({
			type: reducersActions?.GET_USERS,
			payload: res.data,
		});
		return res.data;
	} catch (err) {
		dispatch({
			type: reducersActions?.GET_USERS_ERROR,
			payload: err,
		});
		throw err;
	}
};
